import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  selectDetailsFetchData,
  selectDetailsData
} from 'src/core/redux/selectors';
import { User, Access, UserType } from 'src/core/models';
import { FetchData } from 'src/core/components';
import LocalStorageService from 'src/core/services/LocalStoregeService';

import { fetchAccessAndUserData, resetUserDetails } from './actions';
import AppComponent from './AppComponent';

const AppContainer = ({
  isFetching,
  fetchData,
  resetData,
  accessDetails,
}) => (
  <FetchData
    isFetching={isFetching}
    fetchData={fetchData}
    resetData={resetData}
  >
    <AppComponent accessDetails={accessDetails} />
  </FetchData>
);

AppContainer.propTypes = {
  isFetching: PropTypes.bool,
  fetchData: PropTypes.func.isRequired,
  resetData: PropTypes.func.isRequired,
  accessDetails: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  LocalStorageService.removeItem('loggedUser');

  const userType = selectDetailsData(UserType)(state);
  const userDetails = selectDetailsData(User)(state);
  const accessDetails = selectDetailsData(Access)(state);

  LocalStorageService.setLoggedUser(
    new User({
      ...userDetails,
      isAnonymous: userType.isAnonymous
    })
  );

  const fetchUserTypeDataProps = selectDetailsFetchData(UserType)(state);

  return {
    isFetching: fetchUserTypeDataProps.isFetching,
    accessDetails,
  };
};

const mapDispatchToProps = {
  fetchData: fetchAccessAndUserData,
  resetData: resetUserDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer);
